import React from 'react';

const SectionHeader = ({ header, marginBottom, marginTop }) => {
  return (
    <p
      style={{
        fontSize: '12px',
        fontWeight: 500,
        marginBottom: marginBottom || '0',
        marginTop: marginTop || '0'
      }}
    >
      {header}
    </p>
  );
};

export default SectionHeader;
